// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2Kp3w","fileBtn":"File_fileBtn__3DlMn","closeBtn":"File_closeBtn__21a9I","fileSelected":"File_fileSelected__3ThAF","disabled":"File_disabled__2FXIM"};